import { Outlet } from 'react-router'
import { Layout, MenuProps } from 'antd'
import LeftSiderContent from 'layout/LeftSiderContent'
import useRouterConfigStore from '../store/routerConfigStore'
import useUserStore from 'store/userStore'
import { Roles } from '../api/login-model'
import { LogoutOutlined, UserOutlined } from "@ant-design/icons"
import dropdown_image from '../assets/dropdown.png'
import { useIntl } from "react-intl"
import logo from '../assets/logo.svg'
import meetingStore from "store/meetingStore"
import { logout } from "api"

const { Sider, Header, Content } = Layout

export default function BasicLayout() {
  const { currentRouterConfig } = useRouterConfigStore()
  const navigate = useNavigate()
  const { setLoginInfo, loginInfo } = useUserStore()

  const intl = useIntl()

  useEffect(() => {
    if (!loginInfo) {
      navigate('/login', { replace: true })
    }
  }, [])

    const roleName = useMemo(() => {
    switch (loginInfo?.loginUser?.roleInfo.roleKey) {
      case Roles.Admin:
        return intl.formatMessage({ id: "role.super" })
      case Roles.Business:
        return intl.formatMessage({ id: "role.business" })
      case Roles.Maintenance:
        return intl.formatMessage({ id: "role.configuration" })
      default:
        return intl.formatMessage({ id: "role.default" })
    }
  }, [loginInfo,intl.locale])

  const items: MenuProps['items'] = [
    {
      label: intl.formatMessage({ id: "common.logout" }),
      key: 'quit',
      icon: <LogoutOutlined />,
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    switch (e.key) {
      case "quit":
        logoutHandler();
        break;
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const logoutHandler = async () => {
    setLoginInfo(null)

    const reslut = await logout();
    navigate('/login', { replace: true })
  }

  const [showSider, setShowSider] = useState(false);
  const [showMeeting, setShowMeeting] = useState(false);

  useEffect(() => {
    //非资源管理用户显示左侧菜单
    if (loginInfo?.loginUser?.roleInfo.roleKey != Roles.Maintenance) {
      setShowSider(true);
    }

    if (window.document.URL.includes("/my-meeting")) {
      setShowSider(false);
    }

    // if(window.document.URL.includes("/meeting-invitation"))
    // {
    //   setShowSider(false);
    // }

    if (window.document.URL.includes("/meeting-configuration")) {
      setShowSider(true);
    }
  }, [window.document.URL]);

  const {meetingInfo}=meetingStore();

  const { modal } = App.useApp()
  return (
    <Layout className="tw-h-full tw-bg-transparent">
      {/* {loginInfo?.loginUser?.roleInfo.roleKey != Roles.Maintenance && */}
        <Sider
          className="tw-border-y-0 tw-border-l-0  tw-bg-[#EBF3FF]"
        width={loginInfo?.loginUser?.roleInfo.roleKey == Roles.Business ? 230 : 180}
          hidden={!showSider}
        >
          <LeftSiderContent />
        </Sider>
      {/* } */}
      <Layout className="tw-bg-[#EBF3FF]">
        <Header className="tw-flex tw-justify-between tw-px-5">
          {showSider==true &&
          <div className="tw-flex tw-items-center">
            <div className="tw-bg-[#2B65FE] tw-h-[7.58px] tw-w-[7.58px] tw-rounded-sm tw-mr-2">&nbsp;</div>
            <div className="tw-text-[14px]">
              {currentRouterConfig?.key != null && intl.formatMessage({ id: currentRouterConfig?.key })}
            </div>
              {loginInfo?.loginUser?.roleInfo.roleKey == Roles.Business &&
                <Space className="tw-ml-3">
                  <div>{intl.formatMessage({ id: "table.meeting.name" })}：{meetingInfo?.meeting_name_zh}/{meetingInfo?.meeting_name_en}</div>
                  <div>{intl.formatMessage({ id: "table.meeting.id" })}：{meetingInfo?.meeting_id}</div>
                </Space>
              }
          </div>
          }

          {showSider==false &&
            <div className="tw-flex tw-justify-center">
              <div className="tw-flex tw-justify-around tw-items-center"><img src={logo} width={40} height={40}></img></div>
              <div className="tw-text-[18px] tw-font-bold tw-ml-3">{intl.formatMessage({ id: "system.main.title" })}</div>
            </div>
          }

          <div className="tw-flex tw-items-center">
            {/* {showSider==true&&loginInfo?.loginUser?.roleInfo.roleKey == Roles.Business&&<Button className="tw-mr-2" onClick={()=>
                modal.confirm({
                  title: intl.formatMessage({ id: "common.go.home.confirm" }),
                  onOk() {
                    navigate('/my-meeting', { replace: true })
                  }
                })
              }>{intl.formatMessage({ id: "common.go.home" })}</Button>} */}
            <LangSelect type="header"/>
            <Avatar
              size={34}
              icon={<UserOutlined />}
              className="tw-ml-2"
            />

            <div className="tw-ml-2">
              <Dropdown menu={menuProps}  trigger={['click']}>
                <span className="tw-font-medium tw-text-[12px] tw-cursor-pointer ">
                  {roleName}<img src={dropdown_image} className="tw-ml-1 tw-mb-[2px]" />
                </span>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content className={`tw-pr-5 ${loginInfo?.loginUser?.roleInfo.roleKey == Roles.Admin?"tw-pl-2":"tw-pl-5"} tw-pt-1`}>
          <div className="tw-bg-white tw-my-3 tw-rounded-lg">
          <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}
